module.exports = __webpack_public_path__ + "static/media/Image_2_carpark_Cycloponics.4da60289.jpg";